import { ScrollArea, ScrollBar } from '@/components/ui/scroll-area';
import { cn } from '@/lib/utils';
import { Button } from '@/components/ui/button';

interface TimePickerProps {
    value?: Date;
    onChange: (date: Date) => void;
    className?: string;
}

export function TimePicker({ value, onChange, className }: TimePickerProps) {
    const hours = Array.from({ length: 24 }, (_, i) => i);
    const minutes = Array.from({ length: 60 }, (_, i) => i);

    const selectedDate = value || new Date();
    const selectedHour = selectedDate.getHours();
    const selectedMinute = selectedDate.getMinutes();

    const handleHourClick = (hour: number) => {
        const newDate = new Date(selectedDate);
        newDate.setHours(hour);
        onChange(newDate);
    };

    const handleMinuteClick = (minute: number) => {
        const newDate = new Date(selectedDate);
        newDate.setMinutes(minute);
        onChange(newDate);
    };

    return (
        <div className={cn('flex h-[300px] w-full border-t border-border', className)}>
            {/* Hours Column */}
            <div className="flex-1 border-r border-border">
                <div className="p-2 text-center text-xs font-medium text-muted-foreground border-b border-border">
                    Hours
                </div>
                <ScrollArea className="h-[260px]">
                    <div className="flex flex-col p-2 gap-1">
                        {hours.map((hour) => (
                            <Button
                                key={hour}
                                variant={selectedHour === hour ? 'default' : 'ghost'}
                                size="sm"
                                className={cn(
                                    'w-full justify-center font-normal',
                                    selectedHour === hour && 'font-bold'
                                )}
                                onClick={() => handleHourClick(hour)}
                            >
                                {hour.toString().padStart(2, '0')}
                            </Button>
                        ))}
                    </div>
                    <ScrollBar orientation="vertical" />
                </ScrollArea>
            </div>

            {/* Minutes Column */}
            <div className="flex-1">
                <div className="p-2 text-center text-xs font-medium text-muted-foreground border-b border-border">
                    Minutes
                </div>
                <ScrollArea className="h-[260px]">
                    <div className="flex flex-col p-2 gap-1">
                        {minutes.map((minute) => (
                            <Button
                                key={minute}
                                variant={selectedMinute === minute ? 'default' : 'ghost'}
                                size="sm"
                                className={cn(
                                    'w-full justify-center font-normal',
                                    selectedMinute === minute && 'font-bold'
                                )}
                                onClick={() => handleMinuteClick(minute)}
                            >
                                {minute.toString().padStart(2, '0')}
                            </Button>
                        ))}
                    </div>
                    <ScrollBar orientation="vertical" />
                </ScrollArea>
            </div>
        </div>
    );
}

